module.exports = __webpack_public_path__ + "static/media/Email-Marketing@2x.a6259ea3.png";